import { render } from "./App.vue?vue&type=template&id=eb1de0ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=eb1de0ee&lang=css"
script.render = render

export default script